import { Box, Grid, styled } from '@mui/material';

export const OverviewDetailBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  height: '95vh',
  maxWidth: '928px',
  borderRadius: '2px',
  overflowY: 'visible',
  flexDirection: 'column',
  padding: theme.spacing(1),
  boxShadow: theme.shadows[2],
  backgroundColor: theme.palette.background.paper,
}));

export const StartGridItem = styled(Grid)(() => ({
  left: 0,
  zIndex: 1,
  padding: '2px',
  display: 'flex',
  position: 'sticky',
  textAlign: 'center',
  width: '100px',
  justifyContent: 'center',
}));

export const EndGridItem = styled(Grid)(() => ({
  right: 0,
  zIndex: 2,
  padding: '2px',
  display: 'flex',
  position: 'sticky',
  justifyContent: 'center',
}));
